import styled from "@emotion/styled";
var ButtonContainer = /*#__PURE__*/ styled("div", {
    target: "eldw9yo0"
})("display:flex;justify-content:space-around;a{width:43%;z-index:1;svg{width:100%;}}");
export { ButtonContainer };
